export const getEventId = (event) =>
  (event.detail?.event_id || '').replace(/_/g, '-');

export const changeFueledConsent = (consent) => {
  const fueled = window.fueled || {};

  if (fueled.setConsent) {
    fueled.setConsent({
      analyticsAllowed: consent.analytics,
      preferencesAllowed: consent.preferences,
      firstPartyMarketingAllowed: consent.marketing,
      thirdPartyMarketingAllowed: consent.sale_of_data,
    });
  } else if (typeof fueled.changeConsent === 'function') {
    fueled.changeConsent({
      analytics: consent.analytics,
      preferences: consent.preferences,
      marketing: consent.marketing,
      saleOfData: consent.sale_of_data,
    });
  }
};
